import { app, firestore } from "../lib/firebase";

export default {
  /**
   * See the week stats.
   */
  async seeWeekStats({ commit, getters }) {
    const { data } = await app.functions().httpsCallable("project-weekStats")({
      login: getters.getProject.sip.login
    });

    commit("setWeekStats", data.reverse());
  },

  /**
   * See the last 5 calls.
   */
  async seeCalls({ commit, getters }) {
    const { data } = await app.functions().httpsCallable("project-calls")({
      login: getters.getProject.sip.login
    });

    commit("setCalls", data);
  },

  /**
   * Call the firebase function `project-creditBalance` to see the user account balance.
   */
  async seeAccountBalance({ commit, getters }) {
    const { data } = await app
      .functions()
      .httpsCallable("project-creditBalance")({
      idClient: getters.getProject.sip.idClient
    });

    commit("setAccountBalance", data);
  },

  /**
   * Call the firebase function `project-create` to create a new project.
   * @param {Object} param
   * @param {{
   *  name: String,
   *  phone: String,
   *  email: String
   * }} data
   */
  async createProject({ dispatch, getters }, { name, phone, email }) {
    await app.functions().httpsCallable("project-create")({
      name,
      phone,
      email
    });

    await dispatch("findProject", getters.getUser.uid);
  },

  /**
   * Find a project using the user id.
   */
  async findProject({ commit, getters }) {
    const project = await (await firestore())
      .collection("projects")
      .doc(getters.getUser.uid)
      .get()
      .then(doc => doc.data());

    commit("setProject", project);
  },

  /**
   * Update project information.
   * @param {*} param0
   * @param {*} param1
   */
  async updateProject({ dispatch, state }, { name, phone, email }) {
    if (!name || !phone || !email) throw new Error("Missing params.");

    await (await firestore())
      .collection("projects")
      .doc(state.user.uid)
      .update({
        name,
        phone,
        email
      });

    await dispatch("findProject");
  }
};
